exports.countryDefinition = {
  country: 'Hong Kong',
  code: 'HK',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Village/Town/District' }
  },
  viewFormat: [['company'], ['address'], ['address2'], ['city']],
  formFormat: [['company'], ['address'], ['address2'], ['city']],
  requiredFormFields: [{ field: 'address' }, { field: 'city' }]
};
